import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { DataService } from 'src/app/helpers/data.service';
import { int } from 'src/app/helpers/Types/types';
import { environment } from 'src/environments/environment.development';
import { counts1, countsDto, employee } from '../_reports/interfaces';
import { ReportsService } from '../_reports/reports.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardsService {
  private _cusId: string;
  private _empId: string;
  role: string;
  empType: string;

  private _getTaskCountWithStatus = `${environment.base_url}/api/Count/GetTaskCountByStatus`;
  private _getTotalCounts = `${environment.base_url}/api/Count/GetTotalCounts`;
  private _getClientCount = `${environment.base_url}/api/Count/GetClientCount`;
  private _getTicketCountWithStatus = `${environment.base_url}/api/Count/GetTicketCountByStatus`;
  private _getTaskCountDateWise = `${environment.base_url}/api/Count/GetTaskCountDateWise`;
  private _getTotalTaskCount = `${environment.base_url}/api/Count/GetTotalTaskCountByEmployee`;
  private _getTotalTicketCount = `${environment.base_url}/api/Count/GetTotalTicketCountByCustomer`;
  private _getNewTicketTaskCount = `${environment.base_url}/api/Count/GetNewTicketAndTaskCount`;
  private _getCurrentProjectCount = `${environment.base_url}/api/Count/GetProductAndProjectCount`;
  private _getProjectCountForCustomer = `${environment.base_url}/api/Count/GetProjectCountByCustomer`;
  private _getManagementCount = `${environment.base_url}/api/Reports/GetCounts`;

  private _getTaskChart = `${environment.base_url}/api/Count/GetTaskCountByStatusAndDateRange`;
  private _getTicketChart = `${environment.base_url}/api/Count/GetTicketCountByStatusAndDateRange`;

  // NewReports
  private _getAllReports = `${environment.base_url}/api/NewReports/GetAllReports`;
  private _getDeadlines = `${environment.base_url}/api/NewReports/GetDeadlines`;
  private _getDailyReport = `${environment.base_url}/api/NewReports/GetDailyReport`;

  constructor(
    private _http: HttpClient,
    private _dataServ: DataService,
    private _reportsServ: ReportsService
  ) {
    this.role = _dataServ.roleValue;
    this.empType = _dataServ.empTypeValue;
    if (
      this.role == 'employee'
      // &&
      // ['admin', 'leader', 'manager', 'qam', 'am'].includes(this.empType)
    ) {
      this._empId = '00000000-0000-0000-0000-000000000000';
      this._cusId = '00000000-0000-0000-0000-000000000000';
    } else {
      this._cusId = _dataServ.customerValue?.id;
      this._empId = _dataServ.employeeValue?.id;
    }
  }
  GetTaskCountWithStatus(count: number) {
    return this._http
      .get<any>(`${this._getTaskCountWithStatus}?EmployeeId=${this._empId}`)
      .pipe(
        map((res) => {
          const nr: {
            colors: string[];
            series: { name: 'values'; data: number[] }[];
            xaxis: {
              categories: string[];
              labels: {
                style: {
                  colors: string[];
                  fontSize: string;
                };
              };
            };
          } = {
            colors: [],
            series: [
              {
                name: 'values',
                data: [],
              },
            ],
            xaxis: {
              categories: [],
              labels: {
                style: {
                  colors: [],
                  fontSize: '12px',
                },
              },
            },
          };
          for (const key in res) {
            if (Object.prototype.hasOwnProperty.call(res, key)) {
              const x = res[key];
              nr.xaxis.categories.push(key);
              nr.colors.push(x.statusColor);
              nr.xaxis.labels.style.colors.push(x.statusColor);
              // nr.series.push(((x.count / count) * 100).toFixed(2));
              nr.series[0].data.push(x.count);
            }
          }
          return nr;
        })
      );
  }
  GetTaskChart(dates?: any) {
    return this._http
      .get<any>(
        `${this._getTaskChart}?EmployeeId=${this._empId}&StartDate=${dates.startDate}&EndDate=${dates.endDate}`
      )
      .pipe(
        map((res) => {
          const nr: {
            series: { name: string; data: number[]; color: string }[];
            xaxis: {
              type: 'category';
              categories: string[];
            };
          } = {
            series: [],
            xaxis: {
              type: 'category',
              categories: [],
            },
          };
          for (const i in res) {
            if (Object.prototype.hasOwnProperty.call(res, i)) {
              const x = res[i];
              nr.xaxis.categories.push(i);
              let index = 0;
              for (const j in x) {
                if (Object.prototype.hasOwnProperty.call(x, j)) {
                  const y = x[j];
                  const i = nr.series.findIndex((z) => z.name === j);
                  if (~i) {
                    nr.series[i].data.push(y.count);
                  } else {
                    nr.series.push({
                      data: [y.count],
                      name: j,
                      color: y.statusColor,
                    });
                  }
                  index++;
                }
              }
            }
          }

          return nr;
        })
      );
  }
  GetTicketChart(dates?: any) {
    return this._http
      .get<any>(
        `${this._getTicketChart}?CustomerId=${dates.customerId}&StartDate=${dates.startDate}&EndDate=${dates.endDate}`
      )
      .pipe(
        map((res) => {
          const nr: {
            series: { name: string; data: number[]; color: string }[];
            xaxis: {
              type: 'category';
              categories: string[];
            };
          } = {
            series: [],
            xaxis: {
              type: 'category',
              categories: [],
            },
          };
          for (const i in res) {
            if (Object.prototype.hasOwnProperty.call(res, i)) {
              const x = res[i];
              nr.xaxis.categories.push(i);
              let index = 0;
              for (const j in x) {
                if (Object.prototype.hasOwnProperty.call(x, j)) {
                  const y = x[j];
                  const i = nr.series.findIndex((z) => z.name === j);
                  if (~i) {
                    nr.series[i].data.push(y.count);
                  } else {
                    nr.series.push({
                      data: [y.count],
                      name: j,
                      color: y.statusColor,
                    });
                  }
                  index++;
                }
              }
            }
          }

          return nr;
        })
      );
  }
  GetTotalCounts() {
    return this._http.get<any>(`${this._getTotalCounts}`);
  }
  GetClientCount() {
    return this._http.get<int>(`${this._getClientCount}`);
  }
  GetTicketCountWithStatus(count: number) {
    return this._http
      .get<any>(`${this._getTicketCountWithStatus}?CustomerId=${this._cusId}`)
      .pipe(
        map((res) => {
          const nr: {
            colors: string[];
            series: { name: 'values'; data: number[] }[];
            xaxis: {
              categories: string[];
              labels: {
                style: {
                  colors: string[];
                  fontSize: string;
                };
              };
            };
          } = {
            colors: [],
            series: [
              {
                name: 'values',
                data: [],
              },
            ],
            xaxis: {
              categories: [],
              labels: {
                style: {
                  colors: [],
                  fontSize: '12px',
                },
              },
            },
          };
          for (const key in res) {
            if (Object.prototype.hasOwnProperty.call(res, key)) {
              const x = res[key];
              nr.xaxis.categories.push(key);
              nr.colors.push(x.statusColor);
              nr.xaxis.labels.style.colors.push(x.statusColor);
              // nr.series.push(((x.count / count) * 100).toFixed(2));
              nr.series[0].data.push(x.count);
            }
          }
          return nr;
        })
      );
  }
  GetTaskCountDateWise() {
    return this._http.get<any>(
      `${this._getTaskCountDateWise}?EmployeeId=${this._empId}`
    );
  }
  GetTotalTaskCount() {
    return this._http.get<any>(
      `${this._getTotalTaskCount}?EmployeeId=${this._empId}`
    );
  }
  GetTotalTicketCount() {
    return this._http.get<any>(
      `${this._getTotalTicketCount}?CustomerId=${this._cusId}`
    );
  }
  GetNewTicketTaskCount() {
    return this._http.get<any>(
      `${this._getNewTicketTaskCount}?${
        this._cusId && this._cusId !== '00000000-0000-0000-0000-000000000000'
          ? `CustomerId=${this._cusId}&`
          : ''
      }${
        this._empId && this._empId !== '00000000-0000-0000-0000-000000000000'
          ? `EmployeeId=${this._empId}`
          : ''
      }`,
      {
        responseType: 'json',
      }
    );
  }
  GetCurrentProjectCount() {
    return this._http.get<any>(`${this._getCurrentProjectCount}`, {
      responseType: 'json',
    });
  }
  GetProjectCountForCustomer() {
    return this._http.get<any>(
      `${this._getProjectCountForCustomer}?Id=${this._cusId}`
    );
  }
  GetManagementCounts(): Observable<countsDto> {
    return this._GetManagementCounts(true).pipe(
      map((counts: counts1) => {
        const response: countsDto = {
          projects: [
            { title: 'Projects', count: 0 },
            { title: 'Product', count: 0 },
            { title: 'Ticket', count: 0 },
            { title: 'Bugs', count: 0 },
          ],
          customers: [
            { title: 'Total', count: 0 },
            { title: 'Projects', count: 0 },
            { title: 'Tickets', count: 0 },
          ],
          team: [
            {
              title: 'Team',
              count: counts.team.team.length,
              team: counts.team.team,
            },
            {
              title: 'Working',
              count: counts.team.working.length,
              team: counts.team.working,
            },
            {
              title: 'Leave/Absent',
              count: counts.team.la.length,
              team: counts.team.la,
            },
          ],
          tickets: [
            {
              title: 'Open',
              count: 3,
              text: ['54646213', '54646214', '54646215'],
            },
            {
              title: 'Closed',
              count: 20,
              text: ['Today (0)', '7 Days (4/74 min)', '30 Days (16/64 min)'],
            },
            {
              title: 'Average Time',
              count: 67,
              text: [],
            },
          ],
        };
        response.projects[0].count = counts.projects.projects;
        response.projects[1].count = counts.projects.products;
        response.projects[2].count = counts.projects.cr;
        response.projects[3].count = counts.projects.bugs;

        // response.customers[0].count = counts.customers;
        // response.customers[1].count = counts.projects.total;
        // response.customers[2].count = counts.tickets;

        // response.team[0].count = counts.employee.total;
        // response.team[1].count = counts.employee.manager;
        // response.team[2].count = counts.employee.leader;
        // response.team[3].count = counts.employee.developer;
        // response.team[4].count = counts.employee.intern;
        return response;
      })
    );
  }
  private _counts: counts1 = {
    projects: { projects: 31, products: 10, cr: 34, bugs: 48 },
    team: {
      team: [],
      working: [],
      la: [],
    },
  };
  private _GetManagementCounts(s: boolean): Observable<counts1> {
    for (let i = 0; i < this._reportsServ._employee.length; i++) {
      const x: employee = { ...this._reportsServ._employee[i] };
      x.name = `${x.name} (${x.type.toUpperCase()})`;
      this._counts.team.team.push(x);
    }
    for (let i = 0; i < 8; i++) {
      const x: employee = { ...this._reportsServ._employee[i] };
      x.name = `${x.name} (${Math.floor(Math.random() * 1000)} Hours)`;
      this._counts.team.working.push(x);
    }
    for (let i = 0; i < 3; i++) {
      const x: employee = { ...this._reportsServ._employee[i] };
      x.name = `${x.name} (${Math.floor(Math.random() * 10)})`;
      this._counts.team.la.push(x);
    }
    if (s) return new BehaviorSubject<counts1>(this._counts).asObservable();
    else return this._http.get<counts1>(this._getManagementCount);
  }

  // NewReport
  GetAllReports() {
    return this._http
      .get<any>(this._getAllReports, { responseType: 'json' })
      .pipe(
        map((reports) => {
          reports.tickets.forEach((x: any) => {
            x.text = x.text.split(',');
          });
          // console.log(reports.tickets);

          return reports;
        })
      );
  }
  GetDeadlines() {
    return this._http.get<any>(this._getDeadlines, { responseType: 'json' });
  }
  GetDailyReport() {
    return this._http
      .get<any[]>(this._getDailyReport, { responseType: 'json' })
      .pipe(
        map((res) => {
          return res.reverse().reduce((result, item) => {
            const emp = item.employee;
            if (!result[emp]) result[emp] = { ...item, arr: [], expand: true };
            result[emp].arr.push(item);
            return result;
          }, {});
        })
      )
      .pipe(
        map((res) => {
          for (const employeeData of Object.values(res)) {
            (employeeData as any).arr.shift();
          }
          return res;
        })
      );
  }
}
